import {
  MANUAL_DOWNLOAD_HISTORICAL_FILE,
  MANUAL_DOWNLOAD_TEMPLATE,
  MANUAL_GENERATE_S3_URL,
  MANUAL_TABLE,
  MANUAL_VALIDATE_UPLOADED_FILE,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getManualDownloadTemplate = (kpiName, month, year) => {
  let requestURL = MANUAL_DOWNLOAD_TEMPLATE;
  let obj = { kpi_name: kpiName };

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

//file_name_DD-MM-YYYY:HH:MM:SS
export const getManualGenerateS3URL = (kpiName, fileName) => {
  let requestURL = MANUAL_GENERATE_S3_URL;
  let obj = { kpi_name: kpiName, file_name: fileName };

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getManualTable = (kpiName, page, limit, month, year) => {
  let requestURL = MANUAL_TABLE;
  let obj = { kpi_name: kpiName };

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

// file_name_DD-MM-YYYY:HH:MM:SS
export const getManualValidateUploadedFile = (
  kpiName,
  fileName,
  month,
  year
) => {
  let requestURL = MANUAL_VALIDATE_UPLOADED_FILE;
  let obj = {
    kpi_name: kpiName,
    file_name: fileName,
  };

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  const reqParams = {
    method: methodType.POST,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const putManualUploadTemplateToS3 = (url, file) => {
  // const formData = new FormData();
  // formData.append("file", file, file.name);

  const requestURL = url;
  const reqParams = {
    method: methodType.PUT,
    url: requestURL,
    data: file,
    contentType: contentType.APPLICATION,
    isAuthorized: false,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getManualDownloadHistoricalFile = (filePath) => {
  let requestURL = MANUAL_DOWNLOAD_HISTORICAL_FILE;
  let obj = { file_path: filePath };

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
